import React from 'react';

const SearchIcon = ({className}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" className={className}>
        <path fill="#000" fillRule="evenodd" d="M8.964 17.83a8.705 8.705 0 0 0 5.662-2.064l6.88 6.88a.787.787 0 0 0 .57.236.807.807 0 0 0 .57-1.376l-6.88-6.88a8.851 8.851 0 0 0 2.064-5.662A8.868 8.868 0 0 0 8.964.098C4.09.098.098 4.088.098 8.964c0 4.895 3.99 8.866 8.866 8.866zm0-16.12c4.01 0 7.254 3.264 7.254 7.254a7.249 7.249 0 0 1-7.254 7.254c-4.01 0-7.254-3.263-7.254-7.254 0-3.99 3.264-7.254 7.254-7.254z"/>
    </svg>
);

export default SearchIcon;